document.addEventListener("DOMContentLoaded", () => {
  const selectors = {
    slider: "#product-container.swiper-container",
    mediaItem: "[data-media-id]",
    thumbsContainer: "#product-thumbs.swiper-thumbs",
  };

  document.querySelectorAll("product-media").forEach((productMedia) => {
    const sliderElement = productMedia.querySelector(selectors.slider);
    const thumbsContainer = productMedia.querySelector(selectors.thumbsContainer);

    if (!sliderElement || !thumbsContainer) return;

    // Avoid initializing the same gallery twice if this asset is requested again.
    if (sliderElement.swiper || thumbsContainer.swiper) return;

    const selectedMedia = sliderElement.querySelector("[data-selected]");
    const initialSlide = Number(selectedMedia?.dataset.index || 0);

    const thumbsInstance = new Swiper(thumbsContainer, {
      direction: "horizontal",
      slidesPerView: "auto",
      spaceBetween: 6,
      initialSlide,
      freeMode: false,
      watchSlidesProgress: true,
      breakpoints: {
        993: {
          direction: "vertical",
        },
      },
      navigation: {
        nextEl: productMedia.querySelector("#product-thumb-next"),
        prevEl: productMedia.querySelector("#product-thumb-prev"),
      },
    });

    const sliderInstance = new Swiper(sliderElement, {
      navigation: false,
      spaceBetween: 10,
      centeredSlides: true,
      watchOverflow: true,
      initialSlide,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slidesPerView: 1,
      thumbs: {
        swiper: thumbsInstance,
      },
    });

    // Keep thumbnail clicks deterministic even when a nested image receives
    // the pointer event instead of Swiper's slide element.
    thumbsContainer.addEventListener("click", (event) => {
      const eventTarget = event.target instanceof Element ? event.target : null;
      const thumbnail = eventTarget?.closest("#product-thumb[data-index]");

      if (!thumbnail || !thumbsContainer.contains(thumbnail)) return;

      const slideIndex = Number(thumbnail.dataset.index);

      if (!Number.isInteger(slideIndex)) return;

      sliderInstance.slideTo(slideIndex);
    });

    // Product variants use this hook to select their featured media.
    productMedia.setActiveMedia = (id) => {
      const mediaFound = Array.from(
        sliderElement.querySelectorAll(selectors.mediaItem)
      ).find((media) => Number(media.dataset.mediaId) === Number(id));

      if (!mediaFound) return;

      sliderInstance.slideTo(Number(mediaFound.dataset.index));
    };
  });
});
